// extracted by mini-css-extract-plugin
module.exports = {"logoRU":"LocalizedLogo_logoRU__6lWNu","logoKZ":"LocalizedLogo_logoKZ__wAb9W","logoUZ":"LocalizedLogo_logoUZ__oGJQP","logo":"LocalizedLogo_logo__lvxKS"};